let isInitialized = false;

export function initializeLoginKeyRedirect(): void {
  if (!isInitialized) {
    isInitialized = true;

    const loginElement = <HTMLElement | null>document.querySelector('.js-login-box-header');
    const redirectUrl = loginElement?.dataset?.loginPage;
    if (!redirectUrl) {
      return;
    }
    window.addEventListener('keyup', function (event) {
      if (event.ctrlKey && event.altKey && event.shiftKey) {
        if (event.key.toUpperCase() === 'L') {
          window.open(redirectUrl, '_blank')?.focus();
        }
      }
    });
  }
}
